import React from "react";

// Minimal, dependency-free markdown renderer for legal/policy content.
// Supports: # / ## / ### headings, - bullet lists, **bold**, _italic_, [text](url) links, paragraphs.
function renderInline(text, keyPrefix) {
  const nodes = [];
  let remaining = text;
  let i = 0;
  const pattern = /(\*\*([^*]+)\*\*|_([^_]+)_|\[([^\]]+)\]\(([^)]+)\))/;
  let m;
  while ((m = remaining.match(pattern))) {
    const idx = m.index;
    if (idx > 0) nodes.push(remaining.slice(0, idx));
    if (m[2] !== undefined) nodes.push(<strong key={`${keyPrefix}-b-${i}`} className="text-white font-bold">{m[2]}</strong>);
    else if (m[3] !== undefined) nodes.push(<em key={`${keyPrefix}-i-${i}`} className="text-zinc-400">{m[3]}</em>);
    else if (m[4] !== undefined) nodes.push(<a key={`${keyPrefix}-a-${i}`} href={m[5]} target="_blank" rel="noreferrer" className="text-[#E6B34A] hover:underline">{m[4]}</a>);
    remaining = remaining.slice(idx + m[0].length);
    i += 1;
  }
  if (remaining) nodes.push(remaining);
  return nodes;
}

export default function Markdown({ text = "", className = "" }) {
  const lines = String(text).split("\n");
  const blocks = [];
  let list = [];
  const flushList = (key) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${key}`} className="list-disc pl-6 space-y-1.5 my-3 text-zinc-300">
          {list.map((li, idx) => <li key={idx}>{renderInline(li, `li-${key}-${idx}`)}</li>)}
        </ul>
      );
      list = [];
    }
  };
  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (line.startsWith("### ")) { flushList(idx); blocks.push(<h3 key={idx} className="font-display font-bold text-lg mt-6 mb-2 text-white">{renderInline(line.slice(4), idx)}</h3>); }
    else if (line.startsWith("## ")) { flushList(idx); blocks.push(<h2 key={idx} className="font-display font-extrabold text-xl mt-8 mb-2 text-white">{renderInline(line.slice(3), idx)}</h2>); }
    else if (line.startsWith("# ")) { flushList(idx); blocks.push(<h1 key={idx} className="font-display font-black text-3xl tracking-tight mt-2 mb-3 text-white">{renderInline(line.slice(2), idx)}</h1>); }
    else if (line.startsWith("- ")) { list.push(line.slice(2)); }
    else if (line.trim() === "") { flushList(idx); }
    else { flushList(idx); blocks.push(<p key={idx} className="text-zinc-300 leading-relaxed my-2">{renderInline(line, idx)}</p>); }
  });
  flushList("end");
  return <div className={className} data-testid="markdown-content">{blocks}</div>;
}
